import React from "react";
import { Viewer } from "components/auth/types";

import Templates from "pages/dashboard/template-groups";

type Props = {
  viewer: Viewer;
}

const TemplateSettingsPage: React.FC<Props> = (props) => (
  <Templates viewer={props.viewer} />
);

export default TemplateSettingsPage;
